import { QuestionCircleOutlined } from "@ant-design/icons";
import { Tooltip } from "antd";
import React from "react";

const ModalTooltip = ({ title, placement, color }) => {
	return (
		<Tooltip title={title} placement={placement} color={color}>
			<QuestionCircleOutlined style={{ color: "#686868" }} />
		</Tooltip>
	);
};
export default ModalTooltip;
